import { rgba } from 'polished';
import styled from 'styled-components';

export const PageLoaderWrapper = styled.div`
	/* background-color: rgba(0, 0, 0, 0.1); */
	/* position: sticky; */
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	min-height: 100vh;
	background-color: #fff;
	background-color: ${rgba('#FFF',0.9)};
	z-index: 999999999 !important;
`;
